import { CartProducts } from '../types'

/** -- por cada cambio de un producto en el carrito se valoriza para obtener los
 * montos correctos de sap -- */
export const CART_VALORIZED = 'CART_VALORIZED'
export const CART_VALORIZED_SUCCESS = 'CART_VALORIZED_SUCCESS'
export const CART_VALORIZED_ERROR = 'CART_VALORIZED_ERROR'
export const CART_RESET = 'CART_RESET'

export interface CartValorized {
  type: typeof CART_VALORIZED
  payload: []
}

export interface CartValorizedSuccess {
  type: typeof CART_VALORIZED_SUCCESS
  payload: CartProducts
}

export interface CartValorizedError {
  type: typeof CART_VALORIZED_ERROR
  payload: boolean | number
}

export interface CartReset {
  type: typeof CART_RESET
  payload: []
}
